<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('listeTypeFormatPresse.title')}}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a
              class="button is-addOrEdit"
              :class="{'button-access-no-permission':
                !checkPermissions(permsTypeFormatPresse.maj)}"
              @click="checkPermissions(permsTypeFormatPresse.maj)
                ? $router.push({ name: 'm.presse.type_format_presse-add'})
                : showPopUp()">
              {{$t('listeTypeFormatPresse.actions.add')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form
            @submit.prevent="recherche()"
            class="column">
            <b-input
              v-model="criteresRecherche.auto"
              :placeholder="$t('listeTypeFormatPresse.actions.search')"
              type="search" icon="magnify">
            </b-input>
          </form>
        </div>
      </div>
    </div>
    <v-server-table
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      class="tableWithChildRow tableWithPerPageSelection"
      ref="tableTypeFormatPresse">
      <template slot="afterTable">
        <table-items-in-view @input="$refs.tableTypeFormatPresse.setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected"/>
      </div>
      <div slot="edit" slot-scope="props">
        <div
          @click="checkPermissions(permsTypeFormatPresse.supprimer)
            ? $router.push({
              name: 'm.presse.type_format_presse-edit',
              params: { id: props.row.id }})
            : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(permsTypeFormatPresse.maj)}"
            icon="pencil-box-outline"
            type="is-success"/>
        </div>
      </div>
      <div slot="archiver">
        <div
          @click="checkPermissions(permsTypeFormatPresse.supprimer) ? inProgress() : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            :class="{'text-access-no-permission':
              !checkPermissions(permsTypeFormatPresse.supprimer)}"
            type="is-default"
            icon="archive"/>
        </div>
      </div>
      <div slot="delete">
        <div
          @click="checkPermissions(permsTypeFormatPresse.supprimer) ? inProgress() : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            :class="{'text-access-no-permission':
              !checkPermissions(permsTypeFormatPresse.supprimer)}"
            type="is-danger"
            icon="delete-forever"/>
        </div>
      </div>
    </v-server-table>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { TYPE_FORMAT_PRESSE } from '@/configuration/presse/permissionsPresseConf';
import inProgress from '@/services/general/inProgress';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import typeFormatPresseLignes from '@/components/parametrage/typeFormatPresse/typeFormatPresseLignes';

const Permissions = createNamespacedHelpers('permissions');
const TypeFormatPresse = createNamespacedHelpers('typeFormatPresse');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permsTypeFormatPresse: TYPE_FORMAT_PRESSE,
      unsubscribeValue: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    TableItemsInView,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...TypeFormatPresse.mapGetters({
      typeFormatPresse: 'items',
      totalCount: 'totalCount',
      criteresRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeTypeFormatPresse.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeTypeFormatPresse.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('listeTypeFormatPresse.breadcrumb.liste'), route: { name: '' }, isActive: true },
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeTypeFormatPresse.tab.code'),
          libelle: this.$t('listeTypeFormatPresse.tab.libelle'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        childRow: typeFormatPresseLignes,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadTypeFormatPresse(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.typeFormatPresse,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['code', 'libelle'],
      };
    },
    columns() {
      return ['code', 'libelle', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...TypeFormatPresse.mapActions({
      actionsLoadTypeFormatPresse: 'loadTypeFormatPresse',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableTypeFormatPresse.refresh();
    },
    goFirstPage() {
      this.$refs.tableTypeFormatPresse.setPage(1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageParametrage.typeFormatPresse.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
